import { render, staticRenderFns } from "./HoldManageView.vue?vue&type=template&id=29080177"
import script from "./HoldManageView.vue?vue&type=script&lang=js"
export * from "./HoldManageView.vue?vue&type=script&lang=js"
import style0 from "./HoldManageView.vue?vue&type=style&index=0&id=29080177&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports